export default __webpack_public_path__ + "static/media/tomcat.4a2bd552.png";